module.exports = __webpack_public_path__ + "img/like.059543e1.png";